import React, { useState, useEffect} from "react";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getTaskNotificationAction, getSmsNotificationAction } from "../../src/redux/actions/notificationPanelActions";
import { Tabs, Badge, Tab, Box, Typography, List, ListItem, ListItemText, Button } from "@mui/material";
import { getSelectedCustomerNumber, getSelectedUserChatAction } from '../redux/actions/communicationAction';
import { setSelectedTask } from "../../src/redux/actions/notificationPanelActions";


const NotificationPanel = ({ onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [tabIndex, setTabIndex] = useState(0);
  const [scrollY, setScrollY] = useState(0);

  const taskNotifications = useSelector(state => state.notificationPanel.getTaskNotification) || [];
  const unreadSmsFromRedux = useSelector(state => state.notificationPanel.unreadSmsAlerts) || [];
  const total_unread_count = useSelector((state) => state.communication.total_message_count || 0);

  const [unreadSmsAlerts, setUnreadSmsAlerts] = useState(unreadSmsFromRedux);

  useEffect(() => {
    dispatch(getTaskNotificationAction(0, 10));
    dispatch(getSmsNotificationAction( 0, 10));

  }, [dispatch]);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleSmsClick = (messageIndex, senderPhoneNumber) => {
    // Navigate to chat
    dispatch(getSelectedCustomerNumber(senderPhoneNumber));
    dispatch(getSelectedUserChatAction(senderPhoneNumber));
    navigate(`/chat?messageId=${messageIndex}`);

    // Remove clicked message from unread list
    const updatedSmsAlerts = unreadSmsAlerts.filter((_, index) => index !== messageIndex);
    setUnreadSmsAlerts(updatedSmsAlerts);
  };

  const handleScroll = (event) => {
    setScrollY(event.target.scrollTop);
  };

  const handleTaskClick = (task) => {
    dispatch(setSelectedTask(task));
    navigate("/taskmanagment");
  };

  return (
    <Box sx={{ width: 340, maxHeight: 450, display: "flex", flexDirection: "column", borderRadius: 2, boxShadow: 3, bgcolor: "white" }}>
      <Box sx={{ position: "sticky", top: 0, bgcolor: "#f4f6f8", zIndex: 1, borderBottom: "1px solid #ddd" }}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{
            "& .MuiTab-root": { textTransform: "none", fontWeight: 600, fontFamily: "Poppins, sans-serif", color: "#555" },         
          }}
        >
         <Tab label={`Messages (${total_unread_count})`} />
         <Tab label={`Tasks (${taskNotifications?.content?.length || 0})`} />
        </Tabs>
      </Box>

      <Box sx={{ flexGrow: 1, overflowY: "auto", padding: 2 }} onScroll={handleScroll}>
        {tabIndex === 0 && (
          <List>
            {unreadSmsAlerts.length > 0 ? (
              unreadSmsAlerts.map((msg, index) => (
                <ListItem
                  key={index}
                  divider
                  button
                  onClick={() => handleSmsClick(index, msg.senderPhoneNumber)}
                  sx={{
                    bgcolor: index % 2 === 0 ? "#EAEAEA" : "white",
                    transform: `translateY(${(index * 2) - (scrollY * 0.2)}px)`,
                    transition: "transform 0.2s ease-out",
                    "&:hover": { bgcolor: "#e3f2fd" }
                  }}
                >
                  <ListItemText
                    primary={`${msg.firstName} ${msg.lastName}`}
                    primaryTypographyProps={{
                      noWrap: false,
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 2,
                      wordBreak: "break-word",
                      fontSize: "11px"
                    }}
                  />

                  <Badge
                    badgeContent={msg.unreadCount}
                    color="error"
                    sx={{
                      marginLeft: "auto",
                      "& .MuiBadge-badge": {
                        fontSize: "0.75rem",
                        minWidth: "22px",
                        height: "22px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }
                    }}
                  />
                </ListItem>
              ))
            ) : (
              <Typography sx={{ color: "gray", textAlign: "center" }}>No unread messages.</Typography>
            )}
          </List>
        )}

        {tabIndex === 1 && (
          <List>
            {taskNotifications?.content?.length > 0 ? (
              taskNotifications.content.map((task, index) => (
                <ListItem
                  key={task.id} // Using unique task.id
                  divider
                  button
                  onClick={() => handleTaskClick(task)}
                  sx={{
                    bgcolor: index % 2 === 0 ? "#EAEAEA" : "white",
                    transform: `translateY(${(index * 2) - (scrollY * 0.2)}px)`,
                    transition: "transform 0.2s ease-out",
                    "&:hover": { bgcolor: "#e3f2fd", boxShadow: 2 }
                  }}
                >
                  <ListItemText
                    primary={`${task.taskType || "No Task Type"} - Due: ${
  task.dueDate
    ? (() => {
        const date = new Date(task.dueDate);
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const yyyy = date.getFullYear();
        return `${mm}-${dd}-${yyyy}`;
      })()
    : "N/A"
}`}
                    primaryTypographyProps={{
                      noWrap: false,
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 2,
                      wordBreak: "break-word",
                      fontSize: "10px"
                    }}
                  />
                </ListItem>
              ))
            ) : (
              <Typography sx={{ color: "gray", textAlign: "center" }}>No pending tasks.</Typography>
            )}
          </List>
        )}

      </Box>

      <Box sx={{ textAlign: "center", padding: "10px", borderTop: "1px solid #ddd", bgcolor: "#f4f6f8" }}>
        <Button size="small" onClick={onClose} sx={{ fontWeight: "bold" }}>Snooze</Button>
      </Box>
    </Box>
  );
};

export default NotificationPanel;
